var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"title":_vm.$t('shop.pageTitle'),"description":_vm.$t('shop.pageSubtitle'),"to":{ name: _vm.RouteName.Interactive }}},[_c('v-row',{staticClass:"page-row",attrs:{"no-gutters":""}},[_c('SettingsShop')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }